// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// console.log('Vite ⚡️ Rails');

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails');

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import jQuery from 'jquery';
import { Foundation } from 'foundation-sites';

// import '@hotwired/turbo-rails';
import * as Turbo from '@hotwired/turbo';
import { Application } from '@hotwired/stimulus';

import '@client-side-validations/client-side-validations/src';
import '@client-side-validations/simple-form/src';
import jstz from 'jstz';
import AutoSubmitController from '../controllers/auto_submit_controller';
import TradeFormController from '../controllers/trade_form_controller';
import DatePickerController from '../controllers/date_picker_controller';
import DynamicFieldsController from '../controllers/dynamic_fields_controller';
import TradeListController from '../controllers/trade_list_controller';
import GlobalController from '../controllers/global_controller';
import WhatIfController from '../controllers/what_if_controller';
import PoolController from '../controllers/pool_controller';
import SidebarController from '../controllers/sidebar_controller';
import LoadingController from '../controllers/loading_controller';
import PoolFormController from '../controllers/pool_form_controller';
import PayoutConfigController from '../controllers/payout_config_controller';
import PoolClusterFormController from '../controllers/pool_cluster_form_controller';
import RankingController from '../controllers/ranking_controller';
import ToggleAllCheckboxesController from '../controllers/toggle_all_checkboxes_controller';
import ResetAllController from '../controllers/reset_all_controller';
import AuctionTimerController from '../controllers/auction_timer_controller';
import ModalController from '../controllers/modal_controller';
import PoolSidebarController from '../controllers/pool_sidebar_controller';
import AuctionBidTableController from '../controllers/auction_bid_table_controller';
import PreparationStatusController from '../controllers/preparation_status_controller';
import StageSelectorController from '../controllers/stage_selector_controller';

import './../controllers/turbo_stream_actions_controller';
window.$ = window.jQuery = jQuery;
Foundation.addToJquery(window.$);

window.BB = window.BB || {};

// console.log('starting turbo');
Turbo.start();

// console.log('registering stimulus controllers');
window.Stimulus = Application.start();
Stimulus.register('global', GlobalController);
Stimulus.register('modal', ModalController);
Stimulus.register('auto_submit', AutoSubmitController);
Stimulus.register('trade-form', TradeFormController);
Stimulus.register('date-picker', DatePickerController);
Stimulus.register('dynamic-fields', DynamicFieldsController);
Stimulus.register('trade-list', TradeListController);
Stimulus.register('what-if', WhatIfController);
Stimulus.register('pool', PoolController);
Stimulus.register('pool-form', PoolFormController);
Stimulus.register('pool-cluster-form', PoolClusterFormController);
Stimulus.register('payout-config', PayoutConfigController);
Stimulus.register('sidebar', SidebarController);
Stimulus.register('loading', LoadingController);
Stimulus.register('ranking', RankingController);
Stimulus.register('toggle-all', ToggleAllCheckboxesController);
Stimulus.register('reset-all', ResetAllController);
Stimulus.register('auction-timer', AuctionTimerController);
Stimulus.register('pool-sidebar', PoolSidebarController);
Stimulus.register('auction-bid-table', AuctionBidTableController);
Stimulus.register('preparation-status', PreparationStatusController);
Stimulus.register('stage-selector', StageSelectorController);

// console.log('application.js');

// source: https://stackoverflow.com/a/71974422/56545
// console.log('[disabling turbo forms]')
// document.querySelectorAll('form').forEach(function (el) {
//     // console.log('form turbo', el.dataset.turbo, el.dataset.turbo == undefined)
//     if (el.dataset.turbo == undefined) {
//         el.dataset.turbo = false;
//     }
// });
